// extracted by mini-css-extract-plugin
export default {"wrapper":"fZW_3WXP","wrapper_focus":"sqh1ynr8","wrapperFocus":"sqh1ynr8","wrapper_error":"z4J8kfq3","wrapperError":"z4J8kfq3","input":"L1vlW70a","label":"Qg48sdUG"};